import { createActions } from 'redux-actions';

const actions = createActions({
  LAYOUT: {
    TOGGLE_ADMIN_EDIT_MODE: () => undefined,
  },
});

export default actions.layout;
